module.exports = __webpack_public_path__ + "static/gallery-1-77933f50e8073ce2ed4b4f53772dfac9.png";